<table class="ir-plugin-table" style="margin-bottom: 10px" *ngFor="let item of comments">
  <tr *ngIf="item.From && item.From >= 0">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationcustomercomments.from-source' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ item.From | customercommentfrom }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="item.Comment">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationcustomercomments.comment' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <div
        *ngIf="item?.Comment"
        class="ir-plugin-values th-plugin-values angular-editor-view ir-ph1"
        [innerHtml]="item?.Comment"
      ></div>
    </td>
  </tr>
</table>
